var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(
				_vm.selectRandom([
					'We used the '
						.concat(_vm.getHeterogeneityMeasurement())
						.concat(' to measure heterogeneity among the included trials.'),
					'Heterogeneity was assessed using the '
						.concat(_vm.getHeterogeneityMeasurement())
						.concat('.')
				])
			)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }